import type { TicketBreakdownEntry } from './types';

/** Ported 1:1 from the legacy `getTicketCountsBasedOnType` (libs/shared-old) - a small pure mapping
 * with no UI/analytics dependency, so it's cheaper to re-implement locally than to pull in the old lib. */
export default function getTicketCountsBasedOnType(
	ticketType: TicketBreakdownEntry,
	numAdults?: number,
	numChildren?: number
): { adults?: number; children?: number } {
	let adults: number | undefined;
	let children: number | undefined;

	switch (ticketType.type) {
		case 'UNI':
			adults = numAdults;
			children = numChildren;
			break;
		case 'ADT':
			adults = ticketType.ticketCount;
			break;
		case 'CHD':
			children = ticketType.ticketCount;
			break;
		case 'GRP':
			adults = ticketType.groupNumAdults;
			children = ticketType.groupNumChildren;
			break;
		case 'AAT':
			adults = ticketType.ticketCount;
			break;
		case 'ACD':
			children = ticketType.ticketCount;
			break;
		default:
			adults = undefined;
			children = undefined;
	}

	return { adults, children };
}
